import React from 'react'
import dynamic from 'next/dynamic'
import { PageSettings } from 'types'

export type KindFooters = 'regular' | 'simplified'

const KINDS: Record<KindFooters, React.ComponentType> = {
  regular: dynamic(() => import('./kinds/Regular').then((c) => c.Regular)),
  simplified: dynamic(() =>
    import('./kinds/Simplified').then((c) => c.Simplified),
  ),
}

export const Footer = ({ kind = 'regular' }: PageSettings['footer'] = {}) => {
  const Component = KINDS[kind]

  if (!Component) return <></>

  return <Component />
}
